<template>
  <div class="main-field-block">
    <div v-if="title.includes(field.entryType)" style="margin-bottom: 4px">
      {{ field.title }}
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.LOCATION">
      <div
        class="mb-1"
        :class="{
          'required-color': required && (Object.keys(inputValue).length < 3 || Object.values(inputValue).some((value) => !value)),
        }"
      >
        {{ field.title }}
        <span v-if="required">*</span>
      </div>
      <div style="margin-bottom: 25px">
        <Input
          v-model="inputValue.address"
          :form-group-id="`field-input-Address-${field.key}`"
          :placeholder="locationAddressPlaceholder"
          :noLable="true"
          :required="required"
          :viewMode="viewMode"
        />
      </div>
      <div class="location-box">
        <span style="margin-right: 5px; flex: 1">
          <Input
            v-model="inputValue.lat"
            :noLable="true"
            :form-group-id="`field-input-lat-${field.key}`"
            :placeholder="locationLatitudePlaceholder"
            type="number"
            step="0.01"
            :required="required"
            :viewMode="viewMode"
          />
        </span>
        <span style="margin-left: 5px; flex: 1">
          <Input
            v-model="inputValue.lon"
            :noLable="true"
            :form-group-id="`field-input-lon-${field.key}`"
            :placeholder="locationLongitudePlaceholder"
            type="number"
            step="0.01"
            :required="required"
            :viewMode="viewMode"
          />
        </span>
      </div>
    </div>
    <Checkbox
      v-if="field.entryType === ENTRY_TYPES.CHECKBOX"
      v-model="inputValue"
      :form-group-id="`field-input-checkbox-${field.key}`"
      :placeholder="field.title"
      :required="required || isRequiredWhen"
      :left="0"
      :bottom="0"
      :viewMode="viewMode"
    />
    <Input
      v-if="field.entryType === ENTRY_TYPES.TEXT || field.entryType === ENTRY_TYPES.BAR_CODE"
      v-model="inputValue"
      :form-group-id="`field-input-text-${field.key}`"
      type="text"
      :placeholder="field.title"
      :required="required || isRequiredWhen"
      :viewMode="viewMode"
    />
    <div class="">
      <Textarea
        v-if="field.entryType === ENTRY_TYPES.MULTILINE_TEXT || field.entryType === ENTRY_TYPES.QR_CODE"
        v-model="inputValue"
        :form-group-id="`field-input-multiline-text-${field.key}`"
        :placeholder="field.title"
        :required="required || isRequiredWhen"
        :viewMode="viewMode"
      />
    </div>
    <Input
      v-if="field.entryType === ENTRY_TYPES.INT"
      v-model="inputValue"
      :form-group-id="`field-input-int-${field.key}`"
      type="number"
      :placeholder="field.title"
      :required="required || isRequiredWhen"
      :viewMode="viewMode"
    />
    <Input
      v-if="field.entryType === ENTRY_TYPES.DECIMAL"
      v-model="inputValue"
      :form-group-id="`field-input-decimal-${field.key}`"
      type="number"
      step="0.01"
      :placeholder="field.title"
      :required="required || isRequiredWhen"
      :viewMode="viewMode"
    />
    <div v-if="isFile">
      <div v-if="inputValue && !uploadNew">
        <div>{{ field.title }}</div>
        <span style="cursor: pointer; word-break: break-all" @click="getFile(field.key)">
          {{ 'File' | i18n }}: {{ inputValue.name || inputValue }}
          <BIconEye />
        </span>
        <div>
          <b-button variant="primary" size="sm" @click="() => uploadNewFunction()" v-if="!viewMode">
            {{ 'Upload new' | i18n }}
          </b-button>
        </div>
      </div>
      <FileInput
        v-else
        v-model="inputValue"
        :form-group-id="`field-input-file-${field.key}`"
        :placeholder="field.title"
        :required="required || isRequiredWhen"
        :file-extensions="fileType[field.entryType] || ''"
        :viewMode="viewMode"
      />
      <b-button v-if="$route.name === 'project' && !inputValue && !viewMode" variant="primary" size="sm mt-1" @click="takeScreenshot">
        {{ 'Upload screenshot' | i18n }}
      </b-button>
    </div>
    <Select
      v-if="field.entryType === ENTRY_TYPES.DROPDOWN"
      v-model="inputValue"
      :options="field.values.map((i) => ({ value: i, text: i }))"
      :form-group-id="`field-input-dropdown-${field.key}`"
      :placeholder="field.title"
      :required="required || isRequiredWhen"
      :viewMode="viewMode"
    />
    <div v-if="field.entryType === ENTRY_TYPES.TEXT_BLOCK" class="location-box">
      <span style="margin-right: 5px; width: 50%">
        <Select
          v-model="inputValue"
          :options="field.mappedValues.map((i) => ({ value: i.key, text: i.key }))"
          :form-group-id="`field-input-text-title-${field.key}`"
          :placeholder="field.title"
          :required="required || isRequiredWhen"
          :viewMode="viewMode"
        />
      </span>
      <span style="margin-left: 5px">
        <b-form-text>
          {{ inputValue ? field.mappedValues.find((i) => i.key === inputValue).value : null }}
        </b-form-text>
      </span>
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.LIST" :style="`max-width:${listSizeWidth}px; overflow: scroll;`">
      <span style="margin-right: 5px; width: 100%">
        <BackendSelect
          v-model="inputValue"
          :placeholder="field.title"
          :required="required || isRequiredWhen"
          :request="(ctx) => listService.getItemsById(field.listId, ctx)"
          :limit="limit"
          :viewMode="viewMode"
        />
      </span>
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.DATE_TIME">
      <DateTime v-model="inputValue" type="datetime" :placeholder="field.title" :required="required || isRequiredWhen" :viewMode="viewMode" />
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.TIME">
      <div
        class="mb-1"
        :class="{
          'required-color': (required || isRequiredWhen) && (Object.keys(inputValue).length < 2 || Object.values(inputValue).some((value) => !value)),
        }"
      >
        {{ field.title }}
        <span v-if="required || isRequiredWhen">*</span>
      </div>
      <div class="location-box">
        <span style="margin-right: 5px; flex: 1">
          <Input
            v-model="inputValue.hours"
            :noLable="true"
            :form-group-id="`location-hours-${field.key}`"
            :placeholder="timeHoursPlaceholder"
            :required="required || isRequiredWhen"
            :viewMode="viewMode"
          />
        </span>
        <span style="margin-left: 5px; flex: 1">
          <Input
            v-model="inputValue.minutes"
            :noLable="true"
            :form-group-id="`location-minutes-${field.key}`"
            :placeholder="timeMinutesPlaceholder"
            :required="required || isRequiredWhen"
            :viewMode="viewMode"
          />
        </span>
      </div>
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.DATE">
      <DateTime v-model="inputValue" type="date" :placeholder="field.title" :required="required || isRequiredWhen" :viewMode="viewMode" />
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.PICTURE_IN_TEMPLATE">
      <img :src="getFileURL(field.id)" style="max-width: 100%; max-height: 300px" />
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.PDF_ATTACHMENT">
      <embed :src="getFileURL(field.id)" width="500" height="375" type="application/pdf" />
    </div>
    <div v-if="isDraw">
      <div :class="`d-flex mb-3 ${(required || isRequiredWhen) && !value && isFirstDrawing ? 'required-color' : ''}`">
        {{ field.title }}
        <span v-if="required || isRequiredWhen" class="ml-1">*</span>
      </div>
      <div class="d-flex align-items-stretch" style="margin-left: 3px">
        <img
          v-if="value && !uploadNew && (!inputValue || !inputValue.name)"
          :src="getFileURL(field.key) + `&dymmy=${Math.random()}`"
          style="max-width: calc(100% - 100px); max-height: 300px"
        />
        <div v-else :style="`height: ${canvasSizeHeight}px`">
          <img v-if="inputValue && inputValue.name" :src="URL.createObjectURL(inputValue)" style="max-width: 100%; max-height: 300px" />
          <vue-drawing-canvas
            v-else
            :image.sync="inputValue"
            :ref="field.key"
            :width="canvasSizeWidth"
            :height="canvasSizeHeight"
            :canvasId="'canvasId-' + field.key"
            :lock="(isSignatureDisable && field.entryType === ENTRY_TYPES.SIGNATURE) || viewMode"
            classes="draw-box"
            lineJoin="round"
          />
        </div>
        <div v-if="(!value || uploadNew || (inputValue && inputValue.name)) && !viewMode">
          <b-button
            v-if="field.entryType === ENTRY_TYPES.SIGNATURE ? !isSignatureDisable : true"
            ref="clearBtnRef"
            variant="primary"
            class="height100"
            size="sm"
            @click="() => uploadNewFunction(field.key)"
          >
            {{ 'Clear' | i18n }}
          </b-button>
        </div>
        <div v-else>
          <b-button variant="primary" class="height100" size="sm" @click="() => uploadNewFunction()" v-if="!viewMode">
            {{ 'Create new' | i18n }}
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.MULTIPLE_CHECKBOXES">
      <div :class="`mb-3 ${(required || isRequiredWhen) && !Object.values(inputValue).some((value) => !!value) ? 'required-color' : ''}`">
        {{ field.title }}
        <span v-if="required || isRequiredWhen">*</span>
      </div>
      <div v-for="item in field.mappedValues" :key="item.key">
        <Checkbox
          v-model="inputValue[item.key]"
          :form-group-id="`field-input-checkbox-${field.key}-${item.key}`"
          :placeholder="item.value"
          :left="0"
          :bottom="0"
          :viewMode="viewMode"
        />
      </div>
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.RADIO_BUTTON">
      <Radio
        v-model="inputValue"
        :options="field.mappedValues.map((i) => ({ value: i.key, text: i.value }))"
        small
        :formGroupId="field.key"
        :placeholder="field.title"
        :required="required || isRequiredWhen"
        :viewMode="viewMode"
      />
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.FORMULA">
      <div class="row">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
          <Input
            v-model="inputValue"
            :form-group-id="`${field.unitFieldName}_${field.key}`"
            :placeholder="field.title"
            :input-placeholder="field.unitFieldName"
            :required="required || isRequiredWhen"
            type="number"
            :viewMode="viewMode"
          />
        </div>
      </div>
      <div class="row" v-if="inputValue" style="margin-top: 10px; margin-bottom: 10px">
        <div class="col-lg-6 col-sm-8 col-xs-8">{{ field.unitValue }} {{ field.unitName }} x {{ inputValue }} {{ field.unitFieldName }}</div>
        <div class="col-lg-2 col-sm-4 col-xs-4" style="font-weight: bold">
          {{ Number((Number(inputValue) * Number(field.unitValue)).toFixed(4)) }} {{ field.unitName }}
        </div>
      </div>
    </div>
    <div v-if="field.entryType === ENTRY_TYPES.FEED && inputValue">
      <div class="row">
        <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
          <div class="chat-box">
            <ul class="chat-list" id="chat-list">
              <li v-for="(message, index) in renderFeed" :key="message.id">
                <div
                  v-if="
                    index !== 0 &&
                    feedMessages[index - 1] &&
                    moment.utc(message.createdAt).local().format('DD') !==
                      moment
                        .utc(feedMessages[index - 1].createdAt)
                        .local()
                        .format('DD')
                  "
                  class="chat-time"
                >
                  {{ moment.utc(message.createdAt).local().format('DD MMMM') }}
                </div>
                <div v-if="index === 0" class="chat-time">
                  {{ moment.utc(message.createdAt).local().format('DD MMMM') }}
                </div>
                <div class="chat-bubble">
                  <div v-if="message.type === 'text'">
                    {{ message.message }}
                  </div>
                  <div v-else>
                    <img :src="getFeedImageURL(message.id)" style="max-width: 100%; max-height: 300px" />
                  </div>
                  <div v-if="message.attachments && message.attachments.length" class="chat-attachment">
                    <img v-for="att in message.attachments" :key="att.id" :src="getFeedImageURL(att.id)" style="max-width: 100%; max-height: 300px" />
                  </div>
                  <div class="chat-hours">
                    {{ moment.utc(message.createdAt).local().format('HH:mm') }}
                  </div>
                </div>
              </li>
            </ul>
            <div class="feed-input-wrapper" v-if="!viewMode">
              <div class="feed-input-container">
                <form @submit.prevent="postFeedMessage">
                  <input v-model="feedMessage" type="text" class="feed-input" placeholder="Message" autocomplete="off" />
                </form>
                <div class="send-image" @click="uploadFeedFile">
                  <img style="width: 20px" :src="FileIcon" />
                </div>
                <button type="submit" class="feed-submit-btn" @click="postFeedMessage">
                  <img style="width: 23px" :src="MessageIcon" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="field.showTextInput">
      <div style="margin-top: 25px">
        <Input
          v-if="textInputValue !== null"
          :value="textInputValue"
          :onChange="(v) => onChangeTextInput(v)"
          form-group-id="showTextInput"
          :placeholder="field.textInputName"
          :viewMode="viewMode"
        />
        <Input v-else v-model="field.textInputValue" form-group-id="showTextInput" :placeholder="field.textInputName" :viewMode="viewMode" />
      </div>
    </div>
    <b-form-text class="translation-text"> {{ translation }} </b-form-text>
    <span v-if="field.description" class="description">{{ translationDescription || field.description }}</span>
  </div>
</template>

<script>
import VueDrawingCanvas from 'vue-drawing-canvas';
import moment from 'moment';
import axios from 'axios';
import { BIconEye } from 'bootstrap-vue';
import html2canvas from 'html2canvas';

import { ENTRY_TYPES, ENTRY_TYPE_VALUES, VALIDATION_RULES, EMPTY_FIELD, FILLED_FIELD } from '../../../../../../../../constants';

import api from '../../../../api';

import Input from '../../../common/input';
import Select from '../../../common/select';
import Multiselect from '../../../common/multiselect';
import BackendSelect from '../../../common/backend-select';
import Checkbox from '../../../common/checkbox';
import Radio from '../../../common/radio';
import Textarea from '../../../common/textarea';
import DateTime from '../../../common/date-time';
import FileInput from '../../../common/fileInput';
import { ListMixin, ReportsMixin, DeleteRowMixin, AuthStorageMixin, NotificationMixin } from '../../../../../mixins';
import FileIcon from '../../../../../assets/icons/file.svg';
import MessageIcon from '../../../../../assets/icons/message.svg';

const SIZE_EMPTY_DRAWING_PICTURE = 6502;
const SIZE_EMPTY_SIGNATURE_PICTURE = 1996;

export default {
  name: 'CaseInput',
  components: { Input, Select, Checkbox, Textarea, DateTime, FileInput, BackendSelect, VueDrawingCanvas, BIconEye, Radio },
  mixins: [ListMixin, ReportsMixin, DeleteRowMixin, AuthStorageMixin, NotificationMixin],
  props: {
    field: {
      type: Object,
      default: () => {},
    },
    feeds: {
      type: Object,
      default: () => {},
    },
    lists: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Number, File, Boolean, Object, Array],
      default: null,
    },
    textInputValue: {
      type: String,
      default: null,
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    onChangeTextInput: {
      type: Function,
      default: null,
    },
    getFileURL: {
      type: Function,
      default: () => {},
    },
    isNew: {
      type: Boolean,
      default: true,
    },
    enableTranslation: {
      type: Boolean,
      default: false,
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
    getFile: {
      type: Function,
      default: () => {},
    },
    translateLanguage: {
      type: String,
      default: '',
    },
    showValidation: {
      type: Boolean,
      default: false,
    },
    setScreenshotData: {
      type: Function,
      default: () => {},
    },
    isSignatureDisable: {
      type: Boolean,
      default: false,
    },
    valueForRequiredRules: {
      type: [String, Number, File, Boolean, Object, Array],
      default: null,
    },
  },
  data: (instance) => {
    const maxWidth = instance.field.entryType === ENTRY_TYPES.SIGNATURE ? 600 : 800;

    return {
      URL: window.URL,
      moment: moment,
      FileIcon: FileIcon,
      MessageIcon: MessageIcon,
      inputValue: null,
      ENTRY_TYPES: ENTRY_TYPES,
      required: false,
      limit: null,
      translateInput: [ENTRY_TYPES.TEXT, ENTRY_TYPES.MULTILINE_TEXT],
      fileInput: [ENTRY_TYPES.PHOTO, ENTRY_TYPES.FILE],
      drawInput: [ENTRY_TYPES.SIGNATURE, ENTRY_TYPES.DRAWING],
      title: [ENTRY_TYPES.FEED, ENTRY_TYPES.PICTURE_IN_TEMPLATE, ENTRY_TYPES.PDF_ATTACHMENT],
      feedMessages: [],
      feedMessage: '',
      uploadNew: false,
      lockInputWatch: false,
      ignoreFeedList: true,
      listSizeWidth: 0,
      canvasSizeWidth: maxWidth,
      canvasSizeHeight: 0,
      translation: '',
      translationDescription: '',
      isFirstDrawing: true,
      timeOutDescriptionId: null,
      timeOutId: null,
      timeHoursPlaceholder: 'Hours',
      timeMinutesPlaceholder: 'Minutes',
      locationAddressPlaceholder: 'Address',
      locationLatitudePlaceholder: 'Latitude',
      locationLongitudePlaceholder: 'Longitude',
      fileType: {
        [ENTRY_TYPES.PHOTO]: 'image/*',
      },
      ro: null,
    };
  },
  computed: {
    renderFeed: function () {
      return this.ignoreFeedList ? this.feedMessages : this.feeds[this.value];
    },
    entryTypeName: function () {
      return this.$translate(`ENTRY_${ENTRY_TYPE_VALUES[this.field.entryType]}`);
    },
    isFile: function () {
      return this.fileInput.includes(this.field.entryType);
    },
    isDraw: function () {
      return this.drawInput.includes(this.field.entryType);
    },
    isRequiredWhen: function () {
      const requiredWhenRulesData = this.field.rules.find(({ name }) => name === VALIDATION_RULES.REQUIRED_WHEN);
      const isRequiredWhenEmpty = requiredWhenRulesData && requiredWhenRulesData.referenceComparison === EMPTY_FIELD && !this.valueForRequiredRules;
      const isRequiredWhenFilled = requiredWhenRulesData && requiredWhenRulesData.referenceComparison === FILLED_FIELD && this.valueForRequiredRules;
      return isRequiredWhenEmpty || isRequiredWhenFilled;
    },
  },
  watch: {
    translateLanguage: {
      async handler(currentValue) {
        if (currentValue) {
          this.generateTranslation();
          // this.generateTranslationDescription();
          await this.generatePlaceholdersTranslation();
        }
      },
    },
    enableTranslation: {
      async handler() {
        this.generateTranslation();
        // this.generateTranslationDescription();
      },
    },
    inputValue: {
      async handler(newValue) {
        this.generateTranslation();

        if (this.lockInputWatch) {
          return;
        }
        let v = newValue;
        if (this.isDraw) {
          v = await this.dataUrlToFile(newValue, this.field.key);
          if (v) {
            this.isFirstDrawing = false;
            if (this.field.entryType === ENTRY_TYPES.SIGNATURE && v.size <= SIZE_EMPTY_SIGNATURE_PICTURE) return;
            if (this.field.entryType === ENTRY_TYPES.DRAWING && v.size <= SIZE_EMPTY_DRAWING_PICTURE) return;
          }
        }

        this.onChange(v);
      },
      deep: true,
    },
    value: {
      async handler(newValue) {
        this.lockInputWatch = true;
        if (newValue !== this.inputValue) {
          this.inputValue = this.parseValue(newValue);
        }
        setTimeout(() => {
          this.lockInputWatch = false;
        }, 10);
      },
      deep: true,
    },
    feeds: {
      async handler(newValue) {
        if (newValue[this.value] && newValue[this.value].length) {
          this.ignoreFeedList = false;
          setTimeout(() => {
            const scrollingElement = document.getElementById('chat-list');
            scrollingElement.scrollTo(0, scrollingElement.scrollHeight);
          }, 100);
        }
      },
      deep: true,
    },
  },
  async created() {
    const innerWidth = window.innerWidth;
    const maxCanvas = innerWidth - 120;
    this.listSizeWidth = Math.min(maxCanvas, this.field.entryType === ENTRY_TYPES.SIGNATURE ? 600 : 800);
    this.canvasSizeHeight = this.field.entryType === ENTRY_TYPES.SIGNATURE ? 150 : 400;

    const isRequired = this.field.rules.map((r) => r.name).includes(VALIDATION_RULES.REQUIRED);
    this.required = (this.showValidation || !this.field.editByMobile) && isRequired;
    if (this.field.rules && this.field.rules.map((r) => r.name).includes(VALIDATION_RULES.LIMIT)) {
      const r = this.field.rules.find((r) => r.name === VALIDATION_RULES.LIMIT);
      this.limit = Number(r.value);
    }

    this.inputValue = this.parseValue(this.value);

    if (this.field.entryType === ENTRY_TYPES.FEED && this.inputValue) {
      this.updateFeed();
    }
  },
  mounted() {
    if (this.isDraw) {
      this.ro = new ResizeObserver(this.onResize);
      this.ro.observe(this.$parent.$refs[`wrapperCanvasRef_${this.field.id}`][0]);
    }
  },
  beforeDestroy() {
    if (this.isDraw) {
      this.ro.disconnect();
    }
  },
  methods: {
    onResize() {
      const wrapper = this.$parent.$refs[`wrapperCanvasRef_${this.field.id}`][0] || {};
      const wrapperWidth = wrapper.clientWidth;
      if (wrapperWidth && this.$refs.clearBtnRef) {
        const maxWidth = this.field.entryType === ENTRY_TYPES.SIGNATURE ? 600 : 800;
        const buttonWidth = this.$refs.clearBtnRef.clientWidth;
        const currentWidth = wrapperWidth - buttonWidth - 3;
        this.canvasSizeWidth = currentWidth < maxWidth ? currentWidth : maxWidth;
      }
    },
    async generatePlaceholdersTranslation() {
      const capitalizeFirstLetter = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
      };

      if (this.field.entryType === ENTRY_TYPES.TIME) {
        const hoursTranslatedData = await api.translate.translate({
          message: this.timeHoursPlaceholder,
          language: this.translateLanguage,
        });
        this.timeHoursPlaceholder = capitalizeFirstLetter(hoursTranslatedData.data);
        const minutesTranslatedData = await api.translate.translate({
          message: this.timeMinutesPlaceholder,
          language: this.translateLanguage,
        });
        this.timeMinutesPlaceholder = capitalizeFirstLetter(minutesTranslatedData.data);
      }

      if (this.field.entryType === ENTRY_TYPES.LOCATION) {
        const addressTranslatedData = await api.translate.translate({
          message: this.locationAddressPlaceholder,
          language: this.translateLanguage,
        });
        this.locationAddressPlaceholder = capitalizeFirstLetter(addressTranslatedData.data);
        const latitudeTranslatedData = await api.translate.translate({
          message: this.locationLatitudePlaceholder,
          language: this.translateLanguage,
        });
        this.locationLatitudePlaceholder = capitalizeFirstLetter(latitudeTranslatedData.data);
        const longitudeTranslatedData = await api.translate.translate({
          message: this.locationLongitudePlaceholder,
          language: this.translateLanguage,
        });
        this.locationLongitudePlaceholder = capitalizeFirstLetter(longitudeTranslatedData.data);
      }
    },
    generateTranslation() {
      if (!this.translateInput.includes(this.field.entryType) || !this.enableTranslation || !this.inputValue) {
        this.translation = '';
        return;
      }

      this.translation = '...';
      if (this.timeOutId) {
        clearTimeout(this.timeOutId);
      }

      this.timeOutId = setTimeout(async () => {
        try {
          const translation = await api.translate.translate({ message: this.inputValue, language: this.translateLanguage });
          this.translation = translation.data;
        } catch (e) {
          console.log('generate translation:', e);
        }
      }, 2000);
    },
    // generateTranslationDescription() {
    //   if (!this.field.description || !this.enableTranslation) {
    //     this.translationDescription = '';
    //     return;
    //   }

    //   this.translationDescription = '...';
    //   if (this.timeOutDescriptionId) {
    //     clearTimeout(this.timeOutDescriptionId);
    //   }

    //   this.timeOutDescriptionId = setTimeout(async () => {
    //     try {
    //       const translation = await api.translate.translate({ message: this.field.description, language: this.translateLanguage });
    //       this.translationDescription = translation.data;
    //     } catch (e) {
    //       console.log('generate translation description:', e);
    //     }
    //   }, 2000);
    // },
    async uploadNewFunction(key) {
      await this.deleteSelectedRows(
        {},
        async () => {
          if (key) {
            this.$refs[key].reset();
          }
          this.uploadNew = false;
          this.isFirstDrawing = true;
          if (this.isDraw) {
            this.onChange(null);
          } else {
            this.inputValue = null;
          }
        },
        false
      );
      if (this.isDraw) {
        this.onResize();
      }
    },
    getFeedImageURL(id) {
      const auth = this.authStorageService.getAuth();
      return `${axios.defaults.baseURL}/api/v1/one/feed/message/${id}?authorization=${auth.access_token_link}`;
    },
    async uploadFeedFile() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'image/*';
      input.onchange = async (e) => {
        const file = e.target.files[0];
        if (file) {
          await this.reportsService.postFeedMeesage(this.inputValue, file);
          this.updateFeed();
        }
      };
      input.click();
    },
    async updateFeed() {
      const messages = await this.reportsService.getFeedMeesages(this.inputValue);
      this.feedMessages = messages.data;

      this.ignoreFeedList = true;
      setTimeout(() => {
        const scrollingElement = document.getElementById('chat-list');
        scrollingElement.scrollTo(0, scrollingElement.scrollHeight);
      }, 100);
    },
    async postFeedMessage() {
      await this.reportsService.postFeedMeesage(this.inputValue, this.feedMessage);
      this.feedMessage = '';
      this.updateFeed();
    },
    async dataUrlToFile(dataUrl, fileName) {
      if (!this.$refs[this.field.key]) {
        return this.value;
      }
      const empty = this.$refs[this.field.key].isEmpty();

      if (empty) {
        if (this.value) {
          return this.value;
        } else {
          return null;
        }
      }

      if (dataUrl.indexOf('data:image/png;base64') !== 0) {
        return dataUrl;
      }

      const res = await fetch(dataUrl);
      const blob = await res.blob();
      return new File([blob], fileName + '.png', { type: 'image/png' });
    },
    parseValue(v) {
      if (this.isFile && !this.isNew && this.isDraw) {
        // Set file name as placeholder
        return v;
      } else {
        const stringToObject = [ENTRY_TYPES.LOCATION, ENTRY_TYPES.TIME, ENTRY_TYPES.MULTIPLE_CHECKBOXES];
        if (stringToObject.includes(this.field.entryType)) {
          try {
            return v ? JSON.parse(v) : {};
          } catch (e) {
            return {};
          }
        }
        const stringToArray = [ENTRY_TYPES.LIST];
        if (stringToArray.includes(this.field.entryType)) {
          try {
            return v ? JSON.parse(v) : [];
          } catch (e) {
            return [];
          }
        }
        if (this.field.entryType === ENTRY_TYPES.MULTILINE_TEXT) {
          return v ? v : this.field.defaultValue ? this.field.defaultValue : '';
        }
      }
      return v;
    },
    async takeScreenshot() {
      try {
        const currentDocument = document.getElementById('remoteTrack');
        const video = currentDocument.getElementsByTagName('video')[0];
        const canvas = await html2canvas(video, { allowTaint: true });
        const canvasImg = canvas.toDataURL('image/jpg');
        this.setScreenshotData({ screenshot: canvasImg, field: this.field });
        this.$root.$emit('bv::show::modal', 'send-screenshot-to-file-field');
      } catch (error) {
        this.showNotification({ type: 'error', message: this.$translate('Active video has not pinned') });
      }
    },
  },
};
</script>

<style scoped lang="scss">
li {
  margin-bottom: 0.7rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>

<style lang="scss">
.feed-input::placeholder {
  font-size: 0.8rem;
  color: #9b9b9b;
}

.feed-input {
  padding-right: 6rem;
  padding-left: 40px;
  background-color: #f2f2f2;
  border: none;
  color: rgb(54, 54, 54);
  border-radius: 13px;
  height: 48px;
  width: 100%;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
}

.feed-submit-btn {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  height: 2.3rem;
  width: 2.3rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #3996fb;
  border-radius: 50%;
  box-shadow: 0 3px 3px #7bbafd;
  border: none;
  outline: none;
  text-align: center;
  font-size: 1.2rem;
  padding-top: 0.3rem;
  color: white;
  padding-right: 0.1rem;
}

.send-image {
  position: absolute;
  top: 50%;
  left: 2px;
  transform: translateY(-50%);
  width: 2.3rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.feed-input-container {
  width: 95%;
  height: 100%;
  position: relative;
}
.feed-input-wrapper {
  display: flex;
  justify-content: center;
  position: absolute;
  bottom: 15px;
  width: 100%;
  background: white;
}

.chat-box {
  height: 600px;
  width: calc(100% - 10px);
  box-shadow: 0px 0px 6px -2px rgba(0, 0, 0, 0.27);
  border-radius: 0.2rem;
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;
  padding-bottom: 50px;
  margin-left: 5px;
}

.text-block {
  display: flex;
  justify-content: space-between;
}
.text-block .text-input-group {
  width: 50% !important;
  margin-right: 5px;
}
.text-block small {
  margin-left: 5px;
  width: 100%;
}

.translation-text {
  font-size: 16px;
}
.required-text {
  font-size: 16px;
  color: #dc3545 !important;
}

.vdatetime-input {
  border-radius: 0.2rem;
  width: 100%;
  border: 1px solid #ced4da;
  font-weight: 400;
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: #495057;
}
.vdatetime-overlay {
  z-index: 1000;
}
.location-box {
  display: flex;
}

.b-form-datepicker,
.b-form-timepicker {
  height: 31px !important;
}
.b-form-datepicker label,
.b-form-timepicker label {
  height: 31px !important;
  padding: 0px !important;
  line-height: 31px !important;
}

.main-field-block {
  position: relative;
  margin-top: 15px;
  margin-bottom: 15px;
}

.vdatetime {
  width: 100%;
}

.draw-box {
  box-shadow: 0px 0px 6px -2px rgba(0, 0, 0, 0.27);
  border-radius: 0.2rem;
}

.chat-hours {
  padding-top: 10px;
  align-self: center;
  text-align: right;
  font-size: 10px;
  color: #9b9b9b;
}

.chat-bubble {
  position: relative;
  color: #363636;
  padding: 0.5rem 1rem;
  border-radius: 22px;
  background-color: #ffffff;
  max-width: 30rem;
  font-size: 0.9rem;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
  margin-left: 2rem;
  background-color: #f2f2f2;
  align-self: flex-end;
}

.chat-time {
  font-size: 0.8rem;
  color: #9b9b9b;
  align-self: center;
  padding-bottom: 0.2rem;
  width: 100%;
  text-align: center;
}

.chat-list {
  list-style: none;
  flex-grow: 1;
  overflow-y: auto;
  padding-top: 20px;
  padding-right: 15px;
}

.chat-attachment {
  display: flex;
  flex-wrap: wrap;
}

.main-content {
  min-height: auto !important;
}

.signature-block {
  display: flex;
  align-items: stretch;
}

.height100 {
  height: 100%;
}

.description {
  font-size: 12px;
  color: #80868b;
}

.required-color {
  color: #ed3232;
}
</style>
